import Vue from 'vue'
import * as globals from './globals'

export default {
  components: Object.keys(globals).map(component => globals[component]),
  register() {
    this.components.forEach(global => {
      Vue.component(global.name, global)
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/index.js